import {
  VStack,
  HStack,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  ModalFooter,
  Center,
  Heading,
  StackDivider,
  Box,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

export type ConfirmModalProps = {
  title: string;
  message: string;
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

export default function ConfirmModal({
  title,
  message,
  isOpen,
  onClose,
  onConfirm,
}: ConfirmModalProps) {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm" isCentered>
      <ModalOverlay />
      <ModalContent m={4}>
        <ModalBody>
          <Center mt={4}>
            <VStack spacing={4} justify="space-between" my={3}>
              <Heading fontSize="xl">{title}</Heading>
              <Text fontSize="sm" color="wsGray.500">
                {message}
              </Text>
            </VStack>
          </Center>
        </ModalBody>
        <ModalFooter
          borderTopWidth="1px"
          borderTopColor="admin.gray.300"
          justifyContent="center"
          p={0}
        >
          <HStack align="stretch" w="full" spacing={0} divider={<StackDivider />}>
            <Box as="button" flex="1" p={3} onClick={onClose} _focus={{ boxShadow: 'unset' }}>
              <Text fontSize="sm">{t('cancel')}</Text>
            </Box>
            <Box as="button" flex="1" p={3} onClick={onConfirm} _focus={{ boxShadow: 'unset' }}>
              <Text fontSize="sm">{t('confirm')}</Text>
            </Box>
          </HStack>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
